import { SVGProps } from 'react'

const OurAdvantageousIllustration = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="268"
      height="267"
      viewBox="0 0 268 267"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M104.1 248.493C106.514 249.341 112.51 249.041 114.04 248.313C124.228 243.473 143.886 235.66 148.578 224.636C149.38 222.754 142.109 216.967 141.806 214.715C138.06 209.892 136.463 208.453 135.137 202.106C131.224 183.367 167.846 170.34 144.184 147.349C126.852 130.508 105.951 128.891 124.125 97.8667C142.299 66.8423 146.087 -4.47289 101.262 0.966401C75.5358 4.08807 81.589 41.3101 61.6275 56.455C42.659 70.8466 42.8876 90.68 57.3801 112.358C71.8726 134.036 56.6906 137.435 41.7772 152.68C23.863 170.993 55.333 191.697 70.6714 200.008C83.023 206.7 109.992 232.135 104.1 248.493Z"
        fill="url(#paint0_linear_10923_91189)"
      />
      <mask
        id="mask0_10923_91189"
        maskUnits="userSpaceOnUse"
        x="36"
        y="0"
        width="117"
        height="250"
      >
        <path
          d="M104.096 248.501C106.51 249.348 112.506 249.048 114.037 248.321C124.224 243.481 143.882 235.668 148.575 224.644C149.376 222.761 142.105 216.975 141.802 214.723C138.056 209.9 136.459 208.461 135.134 202.114C131.22 183.375 167.843 170.348 144.18 147.357C126.848 130.516 105.947 128.899 124.121 97.8745C142.295 66.8501 146.083 -4.46508 101.258 0.974214C75.5319 4.09588 81.5851 41.318 61.6236 56.4628C42.6551 70.8544 42.8837 90.6879 57.3762 112.366C71.8687 134.044 56.6867 137.443 41.7733 152.688C23.8591 171.001 55.3291 191.705 70.6675 200.016C83.0191 206.708 109.988 232.143 104.096 248.501Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_10923_91189)">
        <path
          d="M130.57 237.25L131.002 236.917C80.0835 169.926 74.1407 79.7639 115.105 -4.26605L114.617 -4.50781C95.2026 35.3166 86.0228 78.1621 88.0697 119.397C90.2213 162.748 104.918 203.5 130.57 237.25Z"
          fill="#FCFDFE"
        />
        <path
          d="M33.4648 159.425C56.1278 162.802 88.7759 179.037 106.243 195.615L106.615 195.216C89.0798 178.573 56.3005 162.274 33.5446 158.883L33.4648 159.425Z"
          fill="#FCFDFE"
        />
        <path
          d="M120.723 223.987L121.23 223.787C116.688 212.084 118.195 198.517 125.708 183.465C131.217 172.428 139.767 160.863 151.122 149.093L150.731 148.711C139.339 160.522 130.756 172.132 125.222 183.219C117.637 198.416 116.123 212.132 120.723 223.987Z"
          fill="#FCFDFE"
        />
        <path
          d="M88.0045 113.53L88.5206 113.357C81.0868 90.853 61.2988 75.8628 46.0077 67.25L45.7422 67.7285C60.9494 76.2937 80.6259 91.1926 88.0045 113.53Z"
          fill="#FCFDFE"
        />
        <path
          d="M92.668 59.4417L93.1707 59.6508C103.293 34.9545 127.337 20.8144 140.769 14.5837L140.541 14.0859C127.037 20.3504 102.861 34.5725 92.668 59.4417Z"
          fill="#FCFDFE"
        />
      </g>
      <path
        d="M103.645 249.851C105.891 249.81 110.742 247.729 111.785 246.661C118.722 239.555 132.569 227.101 133.113 216.579C133.205 214.782 125.468 212.237 124.539 210.474C119.997 207.645 118.247 206.947 115.24 202.121C106.365 187.873 132.622 165.932 106.186 154.221C86.8225 145.642 69.1075 150.705 74.7324 119.573C80.3572 88.4415 61.9762 28.5022 26.6696 46.6997C6.40693 57.1433 22.6197 85.971 10.7333 104.561C-0.561701 122.226 5.60714 138.504 24.0888 151.938C42.5705 165.371 31.0819 172.818 23.3867 189.946C14.143 210.521 46.3247 217.958 61.4729 220.115C73.6715 221.852 103.57 234.565 103.645 249.851Z"
        fill="url(#paint1_linear_10923_91189)"
      />
      <mask
        id="mask1_10923_91189"
        maskUnits="userSpaceOnUse"
        x="5"
        y="43"
        width="129"
        height="207"
      >
        <path
          d="M103.649 249.851C105.895 249.81 110.746 247.729 111.788 246.661C118.726 239.555 132.573 227.101 133.116 216.579C133.209 214.782 125.472 212.237 124.543 210.474C120.001 207.645 118.251 206.947 115.244 202.121C106.368 187.873 132.626 165.932 106.19 154.221C86.8264 145.642 69.1114 150.705 74.7363 119.573C80.3612 88.4415 61.9801 28.5022 26.6735 46.6997C6.41083 57.1433 22.6236 85.971 10.7372 104.561C-0.557795 122.226 5.61105 138.504 24.0927 151.938C42.5744 165.371 31.0858 172.818 23.3906 189.946C14.1469 210.521 46.3286 217.958 61.4768 220.115C73.6754 221.852 103.574 234.565 103.649 249.851Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_10923_91189)">
        <path
          d="M122.07 232.485L122.325 232.078C60.1573 192.441 28.0726 119.944 36.499 38.1514L36.0236 38.1016C32.0303 76.8657 37.3832 114.989 51.5038 148.35C66.3487 183.422 90.7502 212.516 122.07 232.485Z"
          fill="#FCFDFE"
        />
        <path
          d="M18.5704 198.054C38.2682 193.905 70.073 197.297 89.4684 205.617L89.6554 205.174C70.1837 196.822 38.2514 193.417 18.4727 197.583L18.5704 198.054Z"
          fill="#FCFDFE"
        />
        <path
          d="M109.954 224.562L110.311 224.242C103.039 215.985 100.19 204.342 101.844 189.637C103.057 178.854 106.617 166.707 112.426 153.531L111.99 153.336C106.161 166.556 102.587 178.751 101.369 189.582C99.6997 204.429 102.588 216.198 109.954 224.562Z"
          fill="#FCFDFE"
        />
        <path
          d="M49.6834 143.546L50.0566 143.246C37.1439 126.972 16.3141 120.671 1.11367 118.25L1.03906 118.726C16.1561 121.133 36.8665 127.393 49.6834 143.546Z"
          fill="#FCFDFE"
        />
        <path
          d="M37.2188 97.5226L37.6962 97.5411C38.5926 74.0888 54.1471 55.0778 63.3391 45.8329L63.0015 45.4922C53.76 54.7871 38.1215 73.9061 37.2188 97.5226Z"
          fill="#FCFDFE"
        />
      </g>
      <path
        d="M185.043 78.648C186.381 76.3888 244.143 31.4844 244.143 31.4844L257.076 43.1376C260.848 46.5364 262.646 51.6225 261.975 56.9926L256.696 99.2397L229.427 238.498C228.242 244.55 224.069 249.975 218.343 252.909L201.876 261.344L185.043 78.648Z"
        fill="#6A73BB"
      />
      <path
        d="M235.511 29.2829L93.9345 38.3314C86.7983 38.7875 80.2794 45.4472 79.3092 53.2103L73.5668 99.1624C73.5181 99.5516 73.4841 99.9404 73.4648 100.328L66.5667 238.458C66.1978 245.845 71.0205 251.984 77.7158 252.578L193.743 262.872C201.676 263.576 209.127 257.936 210.808 249.888L242.762 96.8849C242.853 96.4491 242.925 96.0125 242.98 95.576L249.421 44.0342C250.509 35.3268 244.242 28.7249 235.511 29.2829Z"
        fill="url(#paint2_linear_10923_91189)"
      />
      <path
        d="M78.1598 249.037C73.1567 248.606 69.478 243.942 69.7527 238.419L76.6429 99.9771C76.6573 99.6863 76.6832 99.391 76.7197 99.0989L82.4752 53.0428C83.2052 47.2005 88.1327 42.1812 93.4961 41.8516L235.029 33.1556C241.573 32.7535 246.275 37.7296 245.46 44.2512L239.035 95.6627C238.994 95.9888 238.939 96.3191 238.871 96.6442L207.029 249.268C205.78 255.258 200.137 259.546 194.224 259.037L78.1598 249.037Z"
        fill="#BAC2FF"
      />
      <path
        d="M211.314 53.5443L109.357 58.5473C101.151 58.9501 93.6728 66.4279 92.5699 75.2537L89.4847 99.9416C89.4295 100.384 89.3909 100.826 89.3694 101.266L83.2558 225.832C82.8442 234.219 88.402 241.145 96.1131 241.761L176.07 248.151C184.774 248.847 192.968 242.511 194.827 233.564L222.857 98.671C222.957 98.1875 223.038 97.7029 223.098 97.2184L226.476 70.1892C227.684 60.5264 220.847 53.0765 211.314 53.5443Z"
        fill="white"
      />
      <path
        d="M216.472 49.1786C178.789 42.6928 141.925 44.8079 105.822 54.904C99.0666 56.7932 94.1567 64.1345 94.9908 71.0746L99.6881 110.157C100.361 115.754 104.562 119.632 109.96 119.597L193.794 119.067C199.891 119.028 205.791 114.797 208.134 108.744L224.762 65.7923C227.764 58.0367 223.955 50.4665 216.472 49.1786Z"
        fill="#BAC2FF"
      />
      <path
        d="M110.853 112.438C108.448 112.465 106.561 110.739 106.258 108.243L101.496 69C101.314 67.5026 101.719 65.9238 102.638 64.5529C103.563 63.1724 104.881 62.1896 106.35 61.7857C123.639 57.0338 141.331 54.1341 158.943 53.2356C176.984 52.3152 195.477 53.4684 213.916 56.7408C215.525 57.0263 216.798 57.9616 217.5 59.3752C218.198 60.7823 218.231 62.4701 217.592 64.1259L201.096 106.885C200.062 109.565 197.446 111.456 194.741 111.487L110.853 112.438Z"
        fill="white"
      />
      <path
        d="M154.456 89.153C163.788 88.9029 171.964 92.3456 177.852 98.2555L201.06 73.5893C190.14 63.1638 175.194 57.3235 158.333 58.1282C141.848 58.915 126.293 65.9339 113.906 76.7457L129.454 99.238C136.466 93.2098 145.24 89.4 154.456 89.153Z"
        fill="url(#paint3_linear_10923_91189)"
      />
      <path
        d="M151.592 107.873L145.536 102.722L180.467 76.152C180.91 75.8152 181.503 76.2904 181.13 76.6839L151.592 107.873Z"
        fill="url(#paint4_linear_10923_91189)"
      />
      <path
        d="M115.006 94.1805C114.583 93.5193 113.81 92.1121 113.76 90.2223C113.664 86.5502 116.368 83.6861 116.731 83.8505C116.927 83.9392 116.679 85.015 116.54 85.4918C116.25 86.4847 115.939 86.5805 115.965 87.0365C116.018 87.9752 117.364 88.0114 118.073 89.257C118.584 90.1541 118.625 91.4317 118.073 92.4429C117.158 94.1204 115.093 94.1795 115.006 94.1805Z"
        fill="url(#paint5_linear_10923_91189)"
      />
      <path
        d="M57.2499 173.93L58.2892 170.327L53.9505 167.089L51.2461 166.07L52.8473 171.111L57.2499 173.93Z"
        fill="url(#paint6_linear_10923_91189)"
      />
      <path
        d="M62.621 246.487C62.621 246.487 60.2479 252.5 60.8723 255.167C58.3244 255.117 56.6758 254.79 56.6758 254.79C56.6758 254.79 57.6999 252.047 57.8997 250.689C58.1697 248.853 58.1495 245.883 58.1495 245.883L62.621 246.487Z"
        fill="url(#paint7_linear_10923_91189)"
      />
      <path
        d="M88.7821 260.561C88.6286 260.748 88.3564 261.138 88.3336 261.666C88.3211 261.953 88.3862 262.189 88.4681 262.406C88.8727 263.479 89.5083 263.62 90.1941 264.758C90.6131 265.454 90.5339 265.663 90.9179 265.977C91.424 266.391 92.0359 266.415 92.5665 266.421C93.4631 266.431 94.7538 266.399 96.379 266.204C95.5272 265.098 94.6215 263.975 93.6583 262.841C93.2359 262.343 92.8141 261.858 92.3936 261.384L89.8894 260.531C89.5204 260.541 89.1512 260.551 88.7821 260.561Z"
        fill="#26264F"
      />
      <path
        d="M90.865 248.305C90.865 248.305 92.2964 255.828 90.475 257.934C88.9235 260.041 91.2243 258.538 91.2243 258.538L93.9722 260.954L95.6207 263.822C95.6207 263.822 94.1031 256.459 94.5078 253.537C94.9125 250.615 95.1149 248.645 95.1149 248.645L90.865 248.305Z"
        fill="url(#paint8_linear_10923_91189)"
      />
      <path
        d="M96.2594 166.021C96.2594 166.021 100.105 169.486 100.105 183.756C100.105 198.026 98.2831 229.012 98.2831 229.012L95.3685 251.196C95.3685 251.196 92.3465 251.305 90.3227 250.693C88.5014 242.335 85.5333 228.197 86.9501 216.373C87.5572 203.53 81.8906 187.425 81.8906 187.425C81.8906 187.425 77.0335 203.734 73.593 211.888C70.1526 220.042 63.6025 245.587 62.9954 247.422C58.9695 247.79 57.25 246.718 57.25 246.718C57.25 246.718 59.8313 219.227 62.2597 208.83C64.6884 198.434 64.486 173.359 68.5336 166.225C77.6406 162.555 96.2594 166.021 96.2594 166.021Z"
        fill="url(#paint9_linear_10923_91189)"
      />
      <path
        d="M96.2592 166.021C96.2592 166.021 100.105 169.486 100.105 183.756C100.105 198.026 98.2831 229.012 98.2831 229.012L95.3685 251.196C95.3685 251.196 92.3464 251.305 90.3227 250.693C88.5012 242.335 85.5332 228.197 86.9498 216.373C87.5569 203.53 81.8905 187.425 81.8905 187.425C81.8905 187.425 77.0334 203.734 73.593 211.888C70.1525 220.042 63.6023 245.588 62.9952 247.422C58.9695 247.79 57.25 246.718 57.25 246.718C57.25 246.718 59.8314 219.227 62.2597 208.83C64.6884 198.434 64.4861 173.36 68.5335 166.224C77.6404 162.555 96.2592 166.021 96.2592 166.021Z"
        fill="url(#paint10_linear_10923_91189)"
      />
      <path
        opacity="0.25"
        d="M76.2843 192.167C75.0854 200.018 72.6874 204.245 66.6922 209.68C61.8963 213.303 65.4932 221.154 63.6947 227.192C63.0952 229.004 61.2967 230.815 60.6972 232.627C58.4663 237.122 60.55 242.619 59.5384 247.378C57.9643 247.159 57.25 246.718 57.25 246.718C57.25 246.718 59.8314 219.227 62.2597 208.83C64.6884 198.434 64.486 173.359 68.5335 166.224C77.6405 162.555 96.2593 166.021 96.2593 166.021C96.2593 166.021 100.105 169.486 100.105 183.756C100.105 184.914 100.092 186.183 100.07 187.536C96.0785 191.094 87.914 191.885 82.8789 187.94C82.5747 187.71 82.2509 187.57 81.9166 187.501C81.9012 187.456 81.8905 187.426 81.8905 187.426C81.8905 187.426 81.8821 187.454 81.8694 187.496C79.5777 187.075 76.8041 190.072 76.2843 192.167Z"
        fill="url(#paint11_linear_10923_91189)"
      />
      <path
        d="M61.497 257.453C61.497 257.453 62.0884 257.453 62.0392 258.223C61.9898 258.992 62.3055 261.639 59.2991 261.763C56.2925 261.887 55.8289 261.549 55.7303 261.549C55.6318 261.549 56.5189 259.017 56.5189 259.017L57.4802 257.776L60.0678 257.503L61.497 257.453Z"
        fill="#26264F"
      />
      <path
        d="M54.83 260.106C54.8941 259.467 55.2492 258.461 55.6064 257.651C56.1372 256.448 55.7014 255.998 56.2088 254.903C56.3842 254.524 56.5547 254.164 56.9252 253.808C57.0106 253.727 57.8401 252.954 59.0482 252.994C59.286 253.001 59.6521 253.017 60.0477 253.23C60.5139 253.48 60.7474 253.856 60.947 254.186C61.2604 254.705 61.1884 254.864 61.6713 256.35C61.7101 256.469 61.7951 256.728 61.8605 257.086C61.9107 257.36 61.9308 257.59 61.9397 257.747C61.1511 257.747 58.1199 257.871 57.4794 258.343C56.8386 258.815 56.5182 259.609 56.5182 260.404C56.5182 261.198 56.1239 261.57 55.7295 261.546C55.3774 261.523 54.6776 260.866 54.83 260.106Z"
        fill="#444B8C"
      />
      <path
        d="M91.2442 256.875C90.567 256.886 90.0701 257.429 89.6955 258.737C89.3208 260.045 87.5223 261.203 89.6204 260.926C91.7187 260.649 93.2426 263.643 93.9919 264.751C94.7413 265.858 96.7529 266.841 96.703 265.76C96.6531 264.678 95.7655 264.172 95.5157 263.065C95.2659 261.958 92.789 256.851 91.2442 256.875Z"
        fill="#444B8C"
      />
      <path
        d="M55.6572 167.738C55.1593 166.344 52.0517 157.184 57.0744 148.83C61.1861 141.992 68.301 139.76 69.3154 139.459C75.4909 137.622 78.586 139.982 80.5345 137.81C83.8409 134.124 80.0955 121.569 72.8507 119.054C64.6843 116.219 54.8875 127.119 50.9174 134.279C45.7091 143.672 46.991 153.007 47.2924 154.93C48.0755 159.926 49.8964 163.737 51.2456 166.077C52.7161 166.63 54.1866 167.184 55.6572 167.738Z"
        fill="url(#paint12_linear_10923_91189)"
      />
      <path
        d="M76.9842 117.286C84.2737 116.992 89.8954 117.108 93.071 120.305C96.4251 123.681 93.0356 127.493 93.7638 136.325C94.8787 149.846 103.433 153.15 104.076 166.868C104.293 171.49 103.517 175.267 102.914 177.543C101.036 179.897 97.9637 183.221 93.4291 186C86.8305 190.044 83.0039 189.339 73.5272 191.951C58.0262 196.225 56.647 201.314 48.9608 200.017C41.1926 198.707 34.3773 192.122 35.2004 188.506C35.6935 186.34 38.825 186.954 42.4304 183.65C47.0772 179.394 45.2851 175.33 48.818 170.756C53.8925 164.185 60.9621 168.202 65.2865 162.507C69.6608 156.746 67.9258 145.395 64.2385 139.208C61.8301 135.166 60.7988 130.43 58.7493 126.193C58.5791 125.841 58.3814 125.264 58.4685 124.542C58.801 121.782 63.3681 120.285 66.827 119.187C72.1027 117.512 76.3847 117.31 76.9842 117.286Z"
        fill="url(#paint13_linear_10923_91189)"
      />
      <path
        d="M83.1236 116.977L81.6859 116.531C81.6859 116.531 81.31 118.492 76.6873 118.737C74.1216 118.737 72.4628 117.289 72.4628 117.289L71.4805 118.01C71.4805 118.01 73.6356 120.722 77.0632 120.653C81.4869 120.564 83.1236 116.977 83.1236 116.977Z"
        fill="url(#paint14_linear_10923_91189)"
      />
      <path
        d="M80.1964 111.018C79.9194 108.865 78.2294 107.485 77.8606 107.19C76.3167 105.954 76.0023 105.829 75.472 105.728L74.7478 105.617C74.7478 105.617 74.7088 105.618 74.6687 105.621C74.2447 105.646 72.9742 106.146 72.7431 106.31C72.0052 106.832 72.5486 110.535 74.7857 115.139C74.8738 115.529 74.9617 115.919 75.0498 116.309C73.0997 116.654 72.6168 117.008 72.6015 117.291C72.5682 117.904 74.7031 118.686 76.6819 118.737C79.1633 118.801 81.798 117.725 81.7475 116.923C81.727 116.598 81.2591 116.197 79.4573 115.804C79.1756 115.405 78.8942 115.006 78.6126 114.607C78.8684 114.295 80.4004 112.605 80.1964 111.018Z"
        fill="url(#paint15_linear_10923_91189)"
      />
      <path
        d="M77.1271 110.211C76.5643 109.872 76.1356 110.601 76.4007 111.239C76.6658 111.876 77.5566 112.275 78.097 111.895C78.6373 111.515 77.8844 110.668 77.1271 110.211Z"
        fill="url(#paint16_linear_10923_91189)"
      />
      <path
        d="M4.18118 110.2C11.5894 102.102 28.8267 104.323 38.3875 110.827C42.8302 113.849 45.1104 117.418 50.3597 117.718C54.3504 117.946 60.6989 116.434 64.0423 112.08C64.4635 111.531 66.1483 109.23 68.678 106.329C69.7933 105.05 70.9024 103.849 72.6216 103.578C73.0584 103.509 74.5114 103.271 75.4719 104.216C76.2503 104.982 76.4412 106.313 76.2111 107.273C76.0733 107.847 75.8953 107.908 75.9206 108.283C75.9919 109.339 77.9008 109.799 77.7945 110.33C77.7187 110.71 76.7252 110.571 76.554 111.048C76.3666 111.571 77.4577 112.02 77.9264 113.335C78.8047 113.927 79.3596 115.401 79.5516 117.373C79.8338 120.272 79.5447 122.627 78.9994 124.401C76.3739 132.942 74.4957 139.052 69.9505 142.464C63.933 146.98 58.5145 142.81 43.2073 142.15C22.2472 141.247 17.0212 148.404 9.48796 143.508C0.0818004 137.395 -3.51051 118.608 4.18118 110.2Z"
        fill="url(#paint17_linear_10923_91189)"
      />
      <path
        d="M114.12 93.6657C114.307 95.4322 114.94 103.247 109.588 109.845C104.588 116.011 97.5065 117.242 96.1902 117.443C89.8232 118.412 87.0774 115.648 84.8525 117.531C81.0769 120.727 83.083 133.68 89.9184 137.169C97.6232 141.102 108.808 131.654 113.712 125.108C120.147 116.521 120.144 107.097 120.106 105.15C120.009 100.093 118.722 96.0674 117.703 93.5638C117.285 93.4368 116.648 93.2964 115.867 93.3238C115.122 93.3498 114.521 93.5185 114.12 93.6657Z"
        fill="url(#paint18_linear_10923_91189)"
      />
      <path
        opacity="0.25"
        d="M48.7255 194.845C50.5895 192.92 48.5376 189.039 51.2909 186.153C53.8462 183.475 56.7394 185.638 60.8531 183.334C66.1295 180.378 64.6756 174.967 69.7158 172.057C73.3401 169.965 75.0433 172.214 80.6774 171.118C86.302 170.023 93.1527 166.117 96.5367 159.136C97.9746 156.17 98.5046 153.222 98.575 150.586C101.105 155.138 103.729 159.501 104.074 166.864C104.291 171.486 103.515 175.264 102.912 177.539C101.034 179.894 97.9617 183.217 93.4271 185.996C86.8284 190.04 83.0018 189.335 73.5252 191.948C58.0242 196.221 56.645 201.31 48.9587 200.014C43.994 199.176 39.4293 196.184 36.9883 193.19C44.1521 196.402 47.3728 196.242 48.7255 194.845Z"
        fill="url(#paint19_linear_10923_91189)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10923_91189"
          x1="28.1647"
          y1="764.829"
          x2="344.496"
          y2="184.675"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCC4FF" />
          <stop offset="0.9964" stopColor="#6165D7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10923_91189"
          x1="156.805"
          y1="17.5106"
          x2="104.374"
          y2="251.557"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0036" stopColor="#98A1E2" />
          <stop offset="1" stopColor="#6274FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10923_91189"
          x1="97.0065"
          y1="250.786"
          x2="233.538"
          y2="-28.3894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD2FF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10923_91189"
          x1="217.185"
          y1="52.9063"
          x2="213.982"
          y2="101.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0036" stopColor="#98A1E2" />
          <stop offset="1" stopColor="#6274FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10923_91189"
          x1="157.447"
          y1="112.481"
          x2="173.383"
          y2="84.1778"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#444B8C" />
          <stop offset="0.9964" stopColor="#26264F" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_10923_91189"
          x1="114.787"
          y1="87.2429"
          x2="119.004"
          y2="94.014"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#FFD2C9" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_10923_91189"
          x1="55.3587"
          y1="167.699"
          x2="53.654"
          y2="171.179"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#F36F56" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_10923_91189"
          x1="59.6484"
          y1="256.577"
          x2="59.6484"
          y2="245.628"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#F36F56" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_10923_91189"
          x1="92.7791"
          y1="259.696"
          x2="92.7791"
          y2="246.501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#F36F56" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_10923_91189"
          x1="100.105"
          y1="207.871"
          x2="57.25"
          y2="207.871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#311944" />
          <stop offset="1" stopColor="#893976" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_10923_91189"
          x1="124.855"
          y1="250.288"
          x2="118.701"
          y2="184.639"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#444B8C" />
          <stop offset="0.9964" stopColor="#26264F" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_10923_91189"
          x1="89.3121"
          y1="168.403"
          x2="58.1051"
          y2="220.439"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#311944" />
          <stop offset="1" stopColor="#893976" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_10923_91189"
          x1="44.452"
          y1="269.817"
          x2="91.8044"
          y2="137.867"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCC4FF" />
          <stop offset="0.9964" stopColor="#6165D7" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_10923_91189"
          x1="30.2158"
          y1="372.713"
          x2="100.646"
          y2="142.588"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCC4FF" />
          <stop offset="0.9964" stopColor="#6165D7" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_10923_91189"
          x1="85.2779"
          y1="116.016"
          x2="85.0371"
          y2="120.911"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0036" stopColor="#98A1E2" />
          <stop offset="1" stopColor="#6274FF" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_10923_91189"
          x1="73.7348"
          y1="109.447"
          x2="80.7632"
          y2="120.734"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#F36F56" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_10923_91189"
          x1="76.2249"
          y1="107.916"
          x2="80.2468"
          y2="120.156"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC444" />
          <stop offset="0.9964" stopColor="#F36F56" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_10923_91189"
          x1="78.2641"
          y1="61.0445"
          x2="19.3662"
          y2="153.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#444B8C" />
          <stop offset="0.9964" stopColor="#1A1E3D" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_10923_91189"
          x1="80.3212"
          y1="231.101"
          x2="118.339"
          y2="107.049"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCC4FF" />
          <stop offset="0.9964" stopColor="#6165D7" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_10923_91189"
          x1="32.2037"
          y1="303.314"
          x2="59.5157"
          y2="158.023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCC4FF" />
          <stop offset="0.9964" stopColor="#6165D7" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default OurAdvantageousIllustration
